import axios from "axios";
import { API_BASE_URL } from "./apiBaseUrl";

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60_000,
});

/** Helpers around the shared axios instance; paths are relative to API_BASE_URL. */
export const http = {
  get: (url, config) => client.get(url, config),
  post: (url, data, config) => client.post(url, data, config),
  put: (url, data, config) => client.put(url, data, config),
  delete: (url, config) => client.delete(url, config),
};

export default client;
